/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { Box, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { PieChart2 } from "../../../../components/Charts";

const GenderDemographics = ({ data }) => {
    // Add null checks
    if (
        !data ||
        !data.raw_data ||
        !Array.isArray(data.raw_data.total_value?.breakdowns?.[0]?.results)
    ) {
        return null;
    }

    return (
        <Box>
            <Box
                display={"flex"}
                alignItems={"center"}
                gap={0.5}
                margin={"3rem 0 0 0"}
            >
                <Typography variant="h6">Gender Demographics</Typography>

                <Tooltip title={data.raw_data.description} arrow>
                    <InfoIcon fontSize="small" sx={{ margin: 0 }} />
                </Tooltip>
            </Box>
            <PieChart2
                data={data.raw_data.total_value.breakdowns[0].results.map(
                    (item) => {
                        const gender = item.dimension_values[0];
                        let displayName = gender;

                        // Map exact gender values to display names
                        if (gender === "F" || gender === "FEMALE") {
                            displayName = "Female";
                        } else if (gender === "M" || gender === "MALE") {
                            displayName = "Male";
                        } else if (gender === "U" || gender === "UNKNOWN") {
                            displayName = "Others";
                        }

                        return {
                            name: displayName,
                            value: item.value,
                        };
                    }
                )}
                labelKey={"name"}
                dataKey={"value"}
                title="Gender Distribution"
            />
        </Box>
    );
};

export default GenderDemographics;
